/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MenuItemList } from './MenuItemList';
import {
    MenuItemListFromJSON,
    MenuItemListFromJSONTyped,
    MenuItemListToJSON,
} from './MenuItemList';

/**
 * 
 * @export
 * @interface PaginatedMenuItemListList
 */
export interface PaginatedMenuItemListList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedMenuItemListList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedMenuItemListList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedMenuItemListList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<MenuItemList>}
     * @memberof PaginatedMenuItemListList
     */
    results: Array<MenuItemList>;
}

/**
 * Check if a given object implements the PaginatedMenuItemListList interface.
 */
export function instanceOfPaginatedMenuItemListList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function PaginatedMenuItemListListFromJSON(json: any): PaginatedMenuItemListList {
    return PaginatedMenuItemListListFromJSONTyped(json, false);
}

export function PaginatedMenuItemListListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedMenuItemListList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(MenuItemListFromJSON)),
    };
}

export function PaginatedMenuItemListListToJSON(value?: PaginatedMenuItemListList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(MenuItemListToJSON)),
    };
}

